import { combineEpics } from 'redux-observable';
import { dataActions } from './data-actions.js';
import { featureActions } from './feature-actions.js';

export const rootEpic = combineEpics(
  ...dataActions,
  ...featureActions,
);
